var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 20.64a8.678 8.678 0 01-7.2-3.84c.036-2.4 4.8-3.72 7.2-3.72s7.164 1.32 7.2 3.72a8.678 8.678 0 01-7.2 3.84M12 3.6a3.6 3.6 0 11-3.6 3.6A3.6 3.6 0 0112 3.6M12 0a12 12 0 1012 12A12 12 0 0012 0z"
  })));
}

export default SvgIconUser;